export const SOUND_TOGGLE = 'SOUND_TOGGLE';

export const soundToggle = ( sound ) => ( {
    type:  SOUND_TOGGLE,
    sound
} );